/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Taxonomy_Alternatives_DescriptionInputs */

const en_directory_taxonomy_alternatives_description = /** @type {(inputs: Directory_Taxonomy_Alternatives_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start with a product you know, then compare other published tools that may fit your workflow, budget, or platform better.`)
};

const zh_directory_taxonomy_alternatives_description = /** @type {(inputs: Directory_Taxonomy_Alternatives_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从你熟悉的产品开始，对比目录中其他已发布工具，找到更适合工作流、预算或平台的选择。`)
};

/**
* | output |
* | --- |
* | "Start with a product you know, then compare other published tools that may fit your workflow, budget, or platform better." |
*
* @param {Directory_Taxonomy_Alternatives_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_taxonomy_alternatives_description = /** @type {((inputs?: Directory_Taxonomy_Alternatives_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Taxonomy_Alternatives_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_taxonomy_alternatives_description(inputs)
	return zh_directory_taxonomy_alternatives_description(inputs)
});
export { directory_taxonomy_alternatives_description as "directory.taxonomy.alternatives.description" }